import styled from 'styled-components';

export const Img = styled.img`
  ${(props) =>
    props.size === 'sm'
      ? `
          height: 1rem;
          width: 1rem;
        `
      : props.size === 'md'
        ? `
          width: 2rem;
          height: 2rem;
        `
        : `
          width: 3rem;
          height: 3rem;
        `}
`;

Img.defaultProps = {
  size: 'md',
};

interface IProps {
  iconName: string;
  style?: React.CSSProperties;
}

const LocalIcon: React.FC<IProps> = ({ iconName, style }) => {
  return <Img src={iconName} style={style} />;
};

export default LocalIcon;
